import FileXSvg from '@assets/images/svg/file-x.svg';
import React from 'react';
import { View } from 'react-native';

export interface FileXIconProps {
    size?: number;
    color?: string;
}

export function FileXIcon({ size = 80, color = '#333333' }: FileXIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FileXSvg width={size} height={size} color={color} />
        </View>
    );
}

